import React, { useState } from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import { FileUploader } from "react-drag-drop-files";
// import LogoutIcon from "@mui/icons-material/Logout";
import { BsFiletypeXlsx } from "react-icons/bs";
import { Tooltip } from "@mui/material";
import { getChainIdLS, isValidRole } from "../../../utils/utils";
import axios from "axios";

const ConfigureNewRoomExcel = (props) => {
    const [uploadCdsns, setUploadCdsns] = useState(false);
    const [uploadFile, setUploadFile] = useState();
    const [totalHeaderCdsnsCount, setTotalHeaderCdsnsCount] = useState({});
    // const [successCdsns, setSuccessCdsns] = useState([]);
    const [uploadCdsnError, setUploadCdsnError] = useState("")

    let validPermissionClassName = isValidRole("ROOM_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

    const popupCloseHandler = () => {
        setUploadCdsns(false);
        setUploadFile();
        setTotalHeaderCdsnsCount({});
        // props?.handleDataFromChild(successCdsns);
        setUploadCdsnError('');
    }

    const uploadOrDragFileHandler = (file) => {
        // if (file && file.type === 'text/csv') {
        setUploadFile(file);
        // setFileErrorMsg('');
        // } 
        // else {
        //     setFileErrorMsg('Please Upload .CSV file');
        // }

    }

    const uploadFileHandler = () => {
        // if (uploadFile && uploadFile.type === 'text/csv') {
        const formData = new FormData();
        formData.append("file", uploadFile);

        axios.post(`${process.env.REACT_APP_BASE_URL}/upload-room-csv`, formData, { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}`, chainId: getChainIdLS() }, responseType: "blob", })
            .then((response) => {
                setUploadFile('');
                // setSuccessCdsns(JSON.parse(response.headers['success-count']))
                let headerResponse = {
                    successCount: response.headers['success-count'],
                    failureCount: response.headers['failure-count'],
                    totalCount: response.headers['total-count']
                }
                const url = window.URL.createObjectURL(new Blob([response?.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${uploadFile.name.slice(0, -5)}__Room_Configure_Result.xls`); // Set file name
                document.body.appendChild(link);
                link.click();
                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
                setTotalHeaderCdsnsCount(headerResponse);
                setUploadCdsnError('');
                props.hotelRoomList()
            })
            .catch(async (error) => {
                const errorMessage = await error.response?.data?.text();
                setUploadCdsnError(JSON.parse(errorMessage)?.errorMessage);
                console.warn(error);
            });
        // } 
    }
    return (
        <>
            {isValidRole("ROOM_CONFIGURATION_MODIFY")?<Tooltip title="Upload CDSNs from Excel" arrow>
                <button type="button" className="disable-btn" onClick={() => setUploadCdsns(true)}>
                    {/* <LogoutIcon
                        className={`me-1 rotate-270`}
                    /> */}
                    Upload Room from Excel
                </button>
            </Tooltip>:
            <Tooltip title="Don't have permission to Upload from Excel" arrow>
                <span>
                <button type="button" className={`disable-btn ${validPermissionClassName}`} >
                    Upload Room from Excel
                </button>
                </span>
            </Tooltip>}
            {uploadCdsns && <BasicModal
                popupOpen={uploadCdsns}
                bodyMessage={
                    uploadCdsns && !Object?.keys(totalHeaderCdsnsCount).length > 0 ?
                        <>
                            <div className="file-upload">
                                <FileUploader
                                    name="file"
                                    accept=".xlsx"
                                    types={['xlsx']}
                                    multiple={false}
                                    handleChange={uploadOrDragFileHandler}
                                    classes="drag-file"
                                    children={
                                        <>
                                            <BsFiletypeXlsx />
                                            <p className="drag-text">
                                                Drag and drop your file here, or
                                                <span> Browse</span>
                                            </p>
                                            <p className="upload-text">To upload your File.</p>
                                        </>
                                    }
                                />
                                {uploadCdsnError && <p className="required">{uploadCdsnError}</p>}
                            </div>
                            <a
                                href={"https://d305f1yuk1f2xt.cloudfront.net/help/RoomUploadSample1.xlsx"}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                color: "#913aff",
                                textDecoration: "none",
                            }}
                            >Attached Sample Excel file, Click here to download.</a>
                            {uploadFile && <p>Selected File : {uploadFile?.name}</p>}
                        </>
                        : <div className="upload-cdsns">
                            <p className="total-count">Total Rooms Config: {totalHeaderCdsnsCount?.totalCount}</p>
                            <p className="success-count">Room created Successfully: {totalHeaderCdsnsCount?.successCount}</p>
                            <p className="failure-count">Error In Rooms Config: {totalHeaderCdsnsCount?.failureCount}</p>
                            <p className="mt-3">To know more please check the downloaded excel file</p>
                        </div>
                }
                customcss={true}
                footer={
                    uploadCdsns && !Object?.keys(totalHeaderCdsnsCount).length > 0 ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler,
                                buttonPrimaryCustomCss: 'cancel-btn_new'
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Upload",
                                action: uploadFileHandler,
                                buttonSecondaryCustomCss: `${uploadFile ? '' : 'btn-disable'}`
                            }
                        }
                        : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler,
                                buttonPrimaryCustomCss: 'cancel-btn_new'
                            }
                        }
                }
            />}
        </>
    )
}

export default ConfigureNewRoomExcel;